import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserPassportPage = lazy(() => import('../views/update/UserPassportPage'));

export function UserPassportPageLazy() {
	return (
		<PageSuspense>
			<UserPassportPage />
		</PageSuspense>
	);
}
